var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { FormattedMessage } from "@irati/utils/lang";
import { H1, H4, Body } from "@irati/ui/src/Typography";
import { BRAND_LOGO_DIMENSIONS } from "@irati/brand/constants/brand";
import { getBrandLogo } from "@irati/utils/images/getImageSize/getImageSize";
import withBranding from "@irati/brand/withBranding";
import Flex from "@irati/ui/src/Flex";
import { BrandSettingsChoiceImage, BrandSettingsChoiceImageWrapper, Color, HexCode, AlignButton } from "./styled/styled";
var BrandSettings = /** @class */ (function (_super) {
    __extends(BrandSettings, _super);
    function BrandSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrandSettings.prototype.render = function () {
        var _a = this.props.branding, businessLogoUrl = _a.businessLogoUrl, primaryColour = _a.primaryColour;
        var imageUrl = getBrandLogo(businessLogoUrl, BRAND_LOGO_DIMENSIONS.width, BRAND_LOGO_DIMENSIONS.height);
        return (React.createElement(React.Fragment, null,
            React.createElement(H1, null,
                React.createElement(FormattedMessage, { id: "admin.components.brandSettings.headerTwo" })),
            React.createElement(Flex, { marginTop: 4, wrap: "wrap", justifyContent: "space-between" },
                React.createElement(Flex, { direction: "column", maxWidth: "360px", marginBottom: 4 },
                    React.createElement(BrandSettingsChoiceImageWrapper, null,
                        React.createElement(BrandSettingsChoiceImage, { src: imageUrl })),
                    React.createElement(H4, { marginBottom: 1 },
                        React.createElement(FormattedMessage, { id: "admin.components.brandSettings.headerFour.logo" })),
                    React.createElement(Body, null,
                        React.createElement(FormattedMessage, { id: "admin.components.brandSettings.logo.text" })),
                    React.createElement(AlignButton, { marginTop: 2, primary: true, onClick: this.props.handleBrandSettingsClickLogo },
                        React.createElement(FormattedMessage, { id: "admin.components.brandSettings.button.uploadLogo" }))),
                React.createElement(Flex, { direction: "column", maxWidth: "360px", marginBottom: 4 },
                    React.createElement(Color, { background: primaryColour },
                        React.createElement(HexCode, null, primaryColour)),
                    React.createElement(H4, { marginBottom: 1 },
                        React.createElement(FormattedMessage, { id: "admin.components.brandSettings.headerFour.brandColour" })),
                    React.createElement(Body, { style: { flexGrow: 1 } },
                        React.createElement(FormattedMessage, { id: "admin.components.brandSettings.brandColour.text" })),
                    React.createElement(AlignButton, { marginTop: 2, primary: true, onClick: this.props.handleBrandSettingsClickColor },
                        React.createElement(FormattedMessage, { id: "admin.components.brandSettings.button.setColour" }))))));
    };
    return BrandSettings;
}(PureComponent));
export default withBranding(BrandSettings);
